// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__14P9B","icon":"icon__2Bh2R","credit":"credit__28Qoj","love":"love__xNFn6"};